<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="8">
      <vc-col :span="12" xs24>
        <example-title src="example-1.html" title="Multiple, left icons" />
        <vc-collapsible name="collapsible-1">
          <vc-collapsible-item label="Item 1" icon="home">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 2" icon="mdi-view-dashboard">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 3" icon="mdi-page-layout-body">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
        </vc-collapsible>
        <example-title src="example-3.html" title="Single, some disabled" />
        <vc-collapsible name="collapsible-3" :multiple="false" color="orange">
          <vc-collapsible-item label="Item 1">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 2" disabled>
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 3" disabled>
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 4">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 5">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 6">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
        </vc-collapsible>
        <example-title src="example-4.html" title="Single, open and disabled" />
        <vc-collapsible name="collapsible-4" :multiple="false" color="red">
          <vc-collapsible-item label="Item 1">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 2" open>
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 3" disabled>
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 4">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 5">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 6">
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
        </vc-collapsible>
      </vc-col>
      <vc-col :span="12" xs24>
        <example-title src="example-2.html" title="Multiple, nested vc-list" />
        <vc-collapsible name="collapsible-2" color="pink">
          <vc-collapsible-item label="Item 1" has-vc-list open icon="home">
            <vc-list>
              <vc-list-item avatar="/static/images/avatar-01.png" icon="account_circle">
                <vc-list-item-primary-text>Christian Caban</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Admin</vc-list-item-secondary-text>
              </vc-list-item>
              <vc-list-item avatar="/static/images/avatar-02.png" icon="account_circle">
                <vc-list-item-primary-text>Daniel Wright</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Admin</vc-list-item-secondary-text>
              </vc-list-item>
              <vc-list-item avatar="/static/images/avatar-03.png" icon="account_circle">
                <vc-list-item-primary-text>Heidi Gonzalez</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Moderator</vc-list-item-secondary-text>
              </vc-list-item>
              <vc-list-item avatar="/static/images/avatar-04.png" icon="account_circle">
                <vc-list-item-primary-text>Chelsea Clements</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Normal User</vc-list-item-secondary-text>
              </vc-list-item>
              <vc-list-item avatar="/static/images/avatar-05.png" icon="account_circle">
                <vc-list-item-primary-text>Jonathon Strother</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Normal User</vc-list-item-secondary-text>
              </vc-list-item>
              <vc-list-item avatar="/static/images/avatar-06.png" icon="account_circle">
                <vc-list-item-primary-text>Maria Bloomquist</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Normal User</vc-list-item-secondary-text>
              </vc-list-item>
            </vc-list>
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 2" open has-vc-list>
            <vc-list>
              <vc-list-item avatar="home">
                <vc-list-item-primary-text>Primary Text</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Secondary Text</vc-list-item-secondary-text>
              </vc-list-item>
              <vc-list-item avatar="home">
                <vc-list-item-primary-text>Primary Text</vc-list-item-primary-text>
                <vc-list-item-secondary-text>Secondary Text</vc-list-item-secondary-text>
              </vc-list-item>
            </vc-list>
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 3" disabled>
            <vc-lorem-ipsum :repeats="1" />
          </vc-collapsible-item>
          <vc-collapsible-item label="Item 4" open has-vc-list>
            <vc-list>
              <vc-list-item>
                <vc-list-item-primary-text>Primary Text</vc-list-item-primary-text>
              </vc-list-item>
              <vc-list-item>
                <vc-list-item-primary-text>Primary Text</vc-list-item-primary-text>
              </vc-list-item>
            </vc-list>
          </vc-collapsible-item>
        </vc-collapsible>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'CollapsiblePage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/collapsible.vue